import React from "react";

export interface IRefrigeratedTag {
  refrigerated: boolean;
}

export interface IProductSegmentTag {
  className?: string,
  tagText: string;
}

export interface IMedicineTypeTag {
  className?: string,
  tagText: string;
}

export enum ProductSegmentDescription {
  MEDICINE = "MEDICAMENTO",
  MATERIAL = "MATERIAL",
  MATERIAIS = "MATERIAL",
  HIGH_PRICE = "ALTO CUSTO",
  ONCOLOGY = "ONCO",
  NUTRITION = "NUTRICAO",
  VACCINE = "VACINA",
  DEFAULT = "DEFAULT",
  EPI = "EPI",
  OPME = "OPME",
  ESPECIALIDADES = "ESPECIALIDADES",
  DIAGNOSTICO = "DIAGNOSTICO"
}

export enum ProductSegmentTagDescription {
  "MEDICINE" = "Medicamento",
  "MATERIAL" = "Material",
  "HIGH_PRICE" = "Alto Custo",
  "ONCOLOGY" = "Onco",
  "NUTRITION" = "Nutrição",
  "VACCINE" = "Vacina",
  "EPI" = "EPI",
  "OPME" = "OPME",
  "ESPECIALIDADES" = "Especialidades",
  "DIAGNOSTICO" = "Diagnóstico"
}

export const segmentsMinimumPriceLock2 = [ ProductSegmentDescription.MATERIAL, ProductSegmentDescription.NUTRITION ]